exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/*\n * Переменные\n */\n.long-and-truncated[data-v-84e33db4] {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.fas[data-v-84e33db4] {\n  opacity: 0.2;\n  color: #000000;\n}\n.fas[data-v-84e33db4]:hover {\n  opacity: 0.8;\n}\na[data-v-84e33db4] {\n  width: 450px;\n  overflow: hidden;\n  white-space: nowrap;\n  display: inline-block;\n}\n.bulma .table td[data-v-84e33db4] {\n  border: none;\n}", ""]);

// exports
